import * as actionType from '../action';
const initialState = {
  files: [],
};

const ImageReducer = (state = initialState, action) => {
  // console.log(action);
  let oldFiles = [];
  let indexIs = -1;
  switch (action.type) {
    case actionType.FILE_UPDATE:
      oldFiles = [...state.files];
      return {
        ...state,
        files: [...oldFiles, action.newFile],
      };
    case actionType.FILE_DELETE:
      oldFiles = [...state.files];
      oldFiles.map((el, index) =>
        el.name === action.name ? (indexIs = index) : ''
      );
      // delete specific
      oldFiles.splice(indexIs, 1);
      return {
        ...state,
        files: [...oldFiles],
      };
    default:
      return {
        ...state,
      };
  }
};

export default ImageReducer;
